<template>
  <!-- Renders only its slot (no element of its own); it hands the section the heading level HomePage picked. -->
  <slot></slot>
</template>

<script setup>
import {computed, provide} from "vue";
import {SECTION_HEADING_LEVEL} from "@/composables/useSectionHeadingTag.js";

const props = defineProps({
  level: {type: Number, default: 2},
});
provide(SECTION_HEADING_LEVEL, computed(() => props.level));
</script>
